import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { TnBackButton } from '../TnBackButton';
import { TnTypography } from '../TnTypography';

export interface TitleAndBackHeaderDetails {
  title: string;
  closeAction?: () => void;
}

interface TitleAndBackHeaderProps extends TitleAndBackHeaderDetails {
  handleClose: () => void;
}

const TitleAndBackHeader = ({ title, handleClose }: TitleAndBackHeaderProps) => {
  const classes = useStyles();

  return (
    <Grid className={classes.container}>
      <Grid className={classes.headerTextContainer}>
        <div className={classes.backButton}>
          <TnBackButton onClick={handleClose} />
        </div>
        <TnTypography variant="h4">{title}</TnTypography>
      </Grid>
    </Grid>
  );
};

export default TitleAndBackHeader;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: '24px 32px',
      width: '100%',
      boxSizing: 'border-box',
    },
    headerTextContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    backButton: {
      marginRight: '10px',
    },
  }),
);
